import { graphql, Link } from "gatsby";
import Image from "gatsby-image";
import React from "react";
import SEO from "../components/seo";
import TimeTable from "../components/timetable";
import schedule from "../data/class_schedule";
import { filterLessons } from "../tools/utils";

const Kilmersdon = ({ data, location }) => {
  const lessons = filterLessons(schedule, 'kilmersdon');
  return (
    <>
      <SEO
        title="Kilmersdon Village Hall"
        keywords={[`kilmersdon village hall`, `dance`, `lessons`]}
        location={location}
      />
      <Link
        to="/lessons#schedule"
        className="hover:underline text-highlight font-semibold mb-4"
      >
        &larr;Back to Class Schedule
      </Link>
      <article className="flex flex-col items-center md:flex-row md:items-start md:justify-around">
        <div className="text-justify">
          <h2>Kilmersdon Village Hall</h2>
          <p>
            High Street
            <br />
            Kilmersdon
            <br />
            Somerset
            <br /> BA3 5TD
          </p>
        </div>

        <figure className="mt-5 w-4/5 md:w-1/3 md:mt-0 self-center">
          <Image
            className="rounded"
            fluid={data.venue.sharp.fluid}
            alt="Kilmersdon Village Hall"
          />
          <figcaption className="text-xs">Kilmersdon Village Hall.</figcaption>
        </figure>
      </article>
      <section className="md:mx-auto">
        <h2 className="mt-4">Class Times</h2>
        <TimeTable data={lessons} />
      </section>
    </>
  );
};

export const query = graphql`
  query {
    venue: file(relativePath: { eq: "kilmersdon-hall.jpg" }) {
      sharp: childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default Kilmersdon;